export default __webpack_public_path__ + "static/karl-hoffman-1-391d5597dae46ff0b62f3bd1669be5fc.webp";